import { CheckCircleFilled, InfoCircleFilled } from '@ant-design/icons';
import { Space } from 'antd';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { WarningComponent } from '../WarningComponent/WarningComponent';
import './AlertCardComponent.scss';

export interface AlertCardComponentProps {
  type: 'success' | 'warning' | 'error' | 'info' | 'custom';
  message: ReactNode;
  warningBorder?: boolean;
  align?: 'left' | 'center' | 'right';
  showCloseIcon?: boolean;
  paddingClassName?: string;
  onClose?: () => void;
  icon?: ReactNode;
  className?: string;
}

export const AlertCardComponent = ({
  type,
  message,
  warningBorder = false,
  align = 'center',
  showCloseIcon,
  paddingClassName,
  onClose,
  icon,
  className = ''
}: AlertCardComponentProps) => {
  const renderSuccess = () => (
    <Space>
      <CheckCircleFilled className="success-svg" />
      <div>{message}</div>
    </Space>
  );

  const renderWarning = () => (
    <WarningComponent
      textColor="none"
      size="medium"
      text={message}
      iconShape="circle"
      showCloseIcon={showCloseIcon}
      onClose={onClose}
    />
  );

  const renderError = () => (
    <WarningComponent
      textColor="none"
      size="medium"
      text={message}
    />
  );

  const renderInfo = () => (
    <Space>
      <InfoCircleFilled color="#F2C81A" className="info" />
      <div>{message}</div>
    </Space>
  );

  const renderCustom = () => (
    <Space>
      {icon}
      <div>{message}</div>
    </Space>
  );

  const render = () => {
    switch (type) {
      case 'success': return renderSuccess();
      case 'warning': return renderWarning();
      case 'info': return renderInfo();
      case 'custom': return renderCustom();
      case 'error':
      default: return renderError();
    }
  };

  return (
    <div
      className={classNames({
        'alert-card-component': true,
        [type]: !!type,
        [className]: !!className,
        'warning-border': warningBorder,
        [align]: !!align,
        [paddingClassName || '']: !!paddingClassName,
      })}
    >
      {render()}
    </div>
  );
};
